type CountryType = {
  short: string;
  flag: string;
  name: string;
  code: string;
};

const countries: CountryType[] = [
  { short: "AD", flag: "🇦🇩", name: "Andorra", code: "+376" },
  { short: "AE", flag: "🇦🇪", name: "United Arab Emirates", code: "+971" },
  { short: "AF", flag: "🇦🇫", name: "Afghanistan", code: "+93" },
  { short: "AG", flag: "🇦🇬", name: "Antigua and Barbuda", code: "+1268" },
  { short: "AI", flag: "🇦🇮", name: "Anguilla", code: "+1 264" },
  { short: "AL", flag: "🇦🇱", name: "Albania", code: "+355" },
  { short: "AM", flag: "🇦🇲", name: "Armenia", code: "+374" },
  { short: "AO", flag: "🇦🇴", name: "Angola", code: "+244" },
  { short: "AR", flag: "🇦🇷", name: "Argentina", code: "+54" },
  { short: "AS", flag: "🇦🇸", name: "American Samoa", code: "+1 684" },
  { short: "AT", flag: "🇦🇹", name: "Austria", code: "+43" },
  { short: "AU", flag: "🇦🇺", name: "Australia", code: "+61" },
  { short: "AW", flag: "🇦🇼", name: "Aruba", code: "+297" },
  { short: "AZ", flag: "🇦🇿", name: "Azerbaijan", code: "+994" },
  { short: "BA", flag: "🇧🇦", name: "Bosnia and Herzegovina", code: "+387" },
  { short: "BB", flag: "🇧🇧", name: "Barbados", code: "+1 246" },
  { short: "BD", flag: "🇧🇩", name: "Bangladesh", code: "+880" },
  { short: "BE", flag: "🇧🇪", name: "Belgium", code: "+32" },
  { short: "BF", flag: "🇧🇫", name: "Burkina Faso", code: "+226" },
  { short: "BG", flag: "🇧🇬", name: "Bulgaria", code: "+359" },
  { short: "BH", flag: "🇧🇭", name: "Bahrain", code: "+973" },
  { short: "BI", flag: "🇧🇮", name: "Burundi", code: "+257" },
  { short: "BJ", flag: "🇧🇯", name: "Benin", code: "+229" },
  { short: "BL", flag: "🇧🇱", name: "Saint Barthélemy", code: "+590" },
  { short: "BM", flag: "🇧🇲", name: "Bermuda", code: "+1 441" },
  { short: "BN", flag: "🇧🇳", name: "Brunei Darussalam", code: "+673" },
  { short: "BO", flag: "🇧🇴", name: "Bolivia", code: "+591" },
  { short: "BR", flag: "🇧🇷", name: "Brazil", code: "+55" },
  { short: "BS", flag: "🇧🇸", name: "Bahamas", code: "+1 242" },
  { short: "BT", flag: "🇧🇹", name: "Bhutan", code: "+975" },
  { short: "BW", flag: "🇧🇼", name: "Botswana", code: "+267" },
  { short: "BY", flag: "🇧🇾", name: "Belarus", code: "+375" },
  { short: "BZ", flag: "🇧🇿", name: "Belize", code: "+501" },
  { short: "CA", flag: "🇨🇦", name: "Canada", code: "+1" },
  { short: "CC", flag: "🇨🇨", name: "Cocos (Keeling) Islands", code: "+61" },
  { short: "CD", flag: "🇨🇩", name: "Congo", code: "+243" },
  { short: "CF", flag: "🇨🇫", name: "Central African Republic", code: "+236" },
  { short: "CG", flag: "🇨🇬", name: "Congo", code: "+242" },
  { short: "CH", flag: "🇨🇭", name: "Switzerland", code: "+41" },
  { short: "CI", flag: "🇨🇮", name: "Côte D'Ivoire", code: "+225" },
  { short: "CK", flag: "🇨🇰", name: "Cook Islands", code: "+682" },
  { short: "CL", flag: "🇨🇱", name: "Chile", code: "+56" },
  { short: "CM", flag: "🇨🇲", name: "Cameroon", code: "+237" },
  { short: "CN", flag: "🇨🇳", name: "China", code: "+86" },
  { short: "CO", flag: "🇨🇴", name: "Colombia", code: "+57" },
  { short: "CR", flag: "🇨🇷", name: "Costa Rica", code: "+506" },
  { short: "CU", flag: "🇨🇺", name: "Cuba", code: "+53" },
  { short: "CV", flag: "🇨🇻", name: "Cape Verde", code: "+238" },
  { short: "CX", flag: "🇨🇽", name: "Christmas Island", code: "+61" },
  { short: "CY", flag: "🇨🇾", name: "Cyprus", code: "+537" },
  { short: "CZ", flag: "🇨🇿", name: "Czech Republic", code: "+420" },
  { short: "DE", flag: "🇩🇪", name: "Germany", code: "+49" },
  { short: "DJ", flag: "🇩🇯", name: "Djibouti", code: "+253" },
  { short: "DK", flag: "🇩🇰", name: "Denmark", code: "+45" },
  { short: "DM", flag: "🇩🇲", name: "Dominica", code: "+1 767" },
  { short: "DO", flag: "🇩🇴", name: "Dominican Republic", code: "+1 849" },
  { short: "DZ", flag: "🇩🇿", name: "Algeria", code: "+213" },
  { short: "EC", flag: "🇪🇨", name: "Ecuador", code: "+593" },
  { short: "EE", flag: "🇪🇪", name: "Estonia", code: "+372" },
  { short: "EG", flag: "🇪🇬", name: "Egypt", code: "+20" },
  { short: "ER", flag: "🇪🇷", name: "Eritrea", code: "+291" },
  { short: "ES", flag: "🇪🇸", name: "Spain", code: "+34" },
  { short: "ET", flag: "🇪🇹", name: "Ethiopia", code: "+251" },
  { short: "FI", flag: "🇫🇮", name: "Finland", code: "+358" },
  { short: "FJ", flag: "🇫🇯", name: "Fiji", code: "+679" },
  {
    short: "FK",
    flag: "🇫🇰",
    name: "Falkland Islands (Malvinas)",
    code: "+500",
  },
  { short: "FM", flag: "🇫🇲", name: "Micronesia", code: "+691" },
  { short: "FO", flag: "🇫🇴", name: "Faroe Islands", code: "+298" },
  { short: "FR", flag: "🇫🇷", name: "France", code: "+33" },
  { short: "GA", flag: "🇬🇦", name: "Gabon", code: "+241" },
  { short: "GB", flag: "🇬🇧", name: "United Kingdom", code: "+44" },
  { short: "GD", flag: "🇬🇩", name: "Grenada", code: "+1 473" },
  { short: "GE", flag: "🇬🇪", name: "Georgia", code: "+995" },
  { short: "GF", flag: "🇬🇫", name: "French Guiana", code: "+594" },
  { short: "GG", flag: "🇬🇬", name: "Guernsey", code: "+44" },
  { short: "GH", flag: "🇬🇭", name: "Ghana", code: "+233" },
  { short: "GI", flag: "🇬🇮", name: "Gibraltar", code: "+350" },
  { short: "GL", flag: "🇬🇱", name: "Greenland", code: "+299" },
  { short: "GM", flag: "🇬🇲", name: "Gambia", code: "+220" },
  { short: "GN", flag: "🇬🇳", name: "Guinea", code: "+224" },
  { short: "GP", flag: "🇬🇵", name: "Guadeloupe", code: "+590" },
  { short: "GQ", flag: "🇬🇶", name: "Equatorial Guinea", code: "+240" },
  { short: "GR", flag: "🇬🇷", name: "Greece", code: "+30" },
  { short: "GS", flag: "🇬🇸", name: "South Georgia", code: "+500" },
  { short: "GT", flag: "🇬🇹", name: "Guatemala", code: "+502" },
  { short: "GU", flag: "🇬🇺", name: "Guam", code: "+1 671" },
  { short: "GW", flag: "🇬🇼", name: "Guinea-Bissau", code: "+245" },
  { short: "GY", flag: "🇬🇾", name: "Guyana", code: "+595" },
  { short: "HK", flag: "🇭🇰", name: "Hong Kong", code: "+852" },
  { short: "HN", flag: "🇭🇳", name: "Honduras", code: "+504" },
  { short: "HR", flag: "🇭🇷", name: "Croatia", code: "+385" },
  { short: "HT", flag: "🇭🇹", name: "Haiti", code: "+509" },
  { short: "HU", flag: "🇭🇺", name: "Hungary", code: "+36" },
  { short: "ID", flag: "🇮🇩", name: "Indonesia", code: "+62" },
  { short: "IE", flag: "🇮🇪", name: "Ireland", code: "+353" },
  { short: "IL", flag: "🇮🇱", name: "Israel", code: "+972" },
  { short: "IM", flag: "🇮🇲", name: "Isle of Man", code: "+44" },
  { short: "IN", flag: "🇮🇳", name: "India", code: "+91" },
  {
    short: "IO",
    flag: "🇮🇴",
    name: "British Indian Ocean Territory",
    code: "+246",
  },
  { short: "IQ", flag: "🇮🇶", name: "Iraq", code: "+964" },
  { short: "IR", flag: "🇮🇷", name: "Iran", code: "+98" },
  { short: "IS", flag: "🇮🇸", name: "Iceland", code: "+354" },
  { short: "IT", flag: "🇮🇹", name: "Italy", code: "+39" },
  { short: "JE", flag: "🇯🇪", name: "Jersey", code: "+44" },
  { short: "JM", flag: "🇯🇲", name: "Jamaica", code: "+1 876" },
  { short: "JO", flag: "🇯🇴", name: "Jordan", code: "+962" },
  { short: "JP", flag: "🇯🇵", name: "Japan", code: "+81" },
  { short: "KE", flag: "🇰🇪", name: "Kenya", code: "+254" },
  { short: "KG", flag: "🇰🇬", name: "Kyrgyzstan", code: "+996" },
  { short: "KH", flag: "🇰🇭", name: "Cambodia", code: "+855" },
  { short: "KI", flag: "🇰🇮", name: "Kiribati", code: "+686" },
  { short: "KM", flag: "🇰🇲", name: "Comoros", code: "+269" },
  { short: "KN", flag: "🇰🇳", name: "Saint Kitts and Nevis", code: "+1 869" },
  { short: "KP", flag: "🇰🇵", name: "North Korea", code: "+850" },
  { short: "KR", flag: "🇰🇷", name: "South Korea", code: "+82" },
  { short: "KW", flag: "🇰🇼", name: "Kuwait", code: "+965" },
  { short: "KY", flag: "🇰🇾", name: "Cayman Islands", code: "+ 345" },
  { short: "KZ", flag: "🇰🇿", name: "Kazakhstan", code: "+7 7" },
  {
    short: "LA",
    flag: "🇱🇦",
    name: "Lao People's Democratic Republic",
    code: "+856",
  },
  { short: "LB", flag: "🇱🇧", name: "Lebanon", code: "+961" },
  { short: "LC", flag: "🇱🇨", name: "Saint Lucia", code: "+1 758" },
  { short: "LI", flag: "🇱🇮", name: "Liechtenstein", code: "+423" },
  { short: "LK", flag: "🇱🇰", name: "Sri Lanka", code: "+94" },
  { short: "LR", flag: "🇱🇷", name: "Liberia", code: "+231" },
  { short: "LS", flag: "🇱🇸", name: "Lesotho", code: "+266" },
  { short: "LT", flag: "🇱🇹", name: "Lithuania", code: "+370" },
  { short: "LU", flag: "🇱🇺", name: "Luxembourg", code: "+352" },
  { short: "LV", flag: "🇱🇻", name: "Latvia", code: "+371" },
  { short: "LY", flag: "🇱🇾", name: "Libya", code: "+218" },
  { short: "MA", flag: "🇲🇦", name: "Morocco", code: "+212" },
  { short: "MC", flag: "🇲🇨", name: "Monaco", code: "+377" },
  { short: "MD", flag: "🇲🇩", name: "Moldova", code: "+373" },
  { short: "ME", flag: "🇲🇪", name: "Montenegro", code: "+382" },
  { short: "MF", flag: "🇲🇫", name: "Saint Martin (French Part)", code: "+590" },
  { short: "MG", flag: "🇲🇬", name: "Madagascar", code: "+261" },
  { short: "MH", flag: "🇲🇭", name: "Marshall Islands", code: "+692" },
  { short: "MK", flag: "🇲🇰", name: "Macedonia", code: "+389" },
  { short: "ML", flag: "🇲🇱", name: "Mali", code: "+223" },
  { short: "MM", flag: "🇲🇲", name: "Myanmar", code: "+95" },
  { short: "MN", flag: "🇲🇳", name: "Mongolia", code: "+976" },
  { short: "MO", flag: "🇲🇴", name: "Macao", code: "+853" },
  { short: "MP", flag: "🇲🇵", name: "Northern Mariana Islands", code: "+1 670" },
  { short: "MQ", flag: "🇲🇶", name: "Martinique", code: "+596" },
  { short: "MR", flag: "🇲🇷", name: "Mauritania", code: "+222" },
  { short: "MS", flag: "🇲🇸", name: "Montserrat", code: "+1664" },
  { short: "MT", flag: "🇲🇹", name: "Malta", code: "+356" },
  { short: "MU", flag: "🇲🇺", name: "Mauritius", code: "+230" },
  { short: "MV", flag: "🇲🇻", name: "Maldives", code: "+960" },
  { short: "MW", flag: "🇲🇼", name: "Malawi", code: "+265" },
  { short: "MX", flag: "🇲🇽", name: "Mexico", code: "+52" },
  { short: "MY", flag: "🇲🇾", name: "Malaysia", code: "+60" },
  { short: "MZ", flag: "🇲🇿", name: "Mozambique", code: "+258" },
  { short: "NA", flag: "🇳🇦", name: "Namibia", code: "+264" },
  { short: "NC", flag: "🇳🇨", name: "New Caledonia", code: "+687" },
  { short: "NE", flag: "🇳🇪", name: "Niger", code: "+227" },
  { short: "NF", flag: "🇳🇫", name: "Norfolk Island", code: "+672" },
  { short: "NG", flag: "🇳🇬", name: "Nigeria", code: "+234" },
  { short: "NI", flag: "🇳🇮", name: "Nicaragua", code: "+505" },
  { short: "NL", flag: "🇳🇱", name: "Netherlands", code: "+31" },
  { short: "NO", flag: "🇳🇴", name: "Norway", code: "+47" },
  { short: "NP", flag: "🇳🇵", name: "Nepal", code: "+977" },
  { short: "NR", flag: "🇳🇷", name: "Nauru", code: "+674" },
  { short: "NU", flag: "🇳🇺", name: "Niue", code: "+683" },
  { short: "NZ", flag: "🇳🇿", name: "New Zealand", code: "+64" },
  { short: "OM", flag: "🇴🇲", name: "Oman", code: "+968" },
  { short: "PA", flag: "🇵🇦", name: "Panama", code: "+507" },
  { short: "PE", flag: "🇵🇪", name: "Peru", code: "+51" },
  { short: "PF", flag: "🇵🇫", name: "French Polynesia", code: "+689" },
  { short: "PG", flag: "🇵🇬", name: "Papua New Guinea", code: "+675" },
  { short: "PH", flag: "🇵🇭", name: "Philippines", code: "+63" },
  { short: "PK", flag: "🇵🇰", name: "Pakistan", code: "+92" },
  { short: "PL", flag: "🇵🇱", name: "Poland", code: "+48" },
  { short: "PM", flag: "🇵🇲", name: "Saint Pierre and Miquelon", code: "+508" },
  { short: "PN", flag: "🇵🇳", name: "Pitcairn", code: "+872" },
  { short: "PR", flag: "🇵🇷", name: "Puerto Rico", code: "+1 939" },
  { short: "PS", flag: "🇵🇸", name: "Palestinian Territory", code: "+970" },
  { short: "PT", flag: "🇵🇹", name: "Portugal", code: "+351" },
  { short: "PW", flag: "🇵🇼", name: "Palau", code: "+680" },
  { short: "PY", flag: "🇵🇾", name: "Paraguay", code: "+595" },
  { short: "QA", flag: "🇶🇦", name: "Qatar", code: "+974" },
  { short: "RE", flag: "🇷🇪", name: "Réunion", code: "+262" },
  { short: "RO", flag: "🇷🇴", name: "Romania", code: "+40" },
  { short: "RS", flag: "🇷🇸", name: "Serbia", code: "+381" },
  { short: "RU", flag: "🇷🇺", name: "Russia", code: "+7" },
  { short: "RW", flag: "🇷🇼", name: "Rwanda", code: "+250" },
  { short: "SA", flag: "🇸🇦", name: "Saudi Arabia", code: "+966" },
  { short: "SB", flag: "🇸🇧", name: "Solomon Islands", code: "+677" },
  { short: "SC", flag: "🇸🇨", name: "Seychelles", code: "+248" },
  { short: "SD", flag: "🇸🇩", name: "Sudan", code: "+249" },
  { short: "SE", flag: "🇸🇪", name: "Sweden", code: "+46" },
  { short: "SG", flag: "🇸🇬", name: "Singapore", code: "+65" },
  {
    short: "SH",
    flag: "🇸🇭",
    name: "Saint Helena, Ascension and Tristan Da Cunha",
    code: "+290",
  },
  { short: "SI", flag: "🇸🇮", name: "Slovenia", code: "+386" },
  { short: "SJ", flag: "🇸🇯", name: "Svalbard and Jan Mayen", code: "+47" },
  { short: "SK", flag: "🇸🇰", name: "Slovakia", code: "+421" },
  { short: "SL", flag: "🇸🇱", name: "Sierra Leone", code: "+232" },
  { short: "SM", flag: "🇸🇲", name: "San Marino", code: "+378" },
  { short: "SN", flag: "🇸🇳", name: "Senegal", code: "+221" },
  { short: "SO", flag: "🇸🇴", name: "Somalia", code: "+252" },
  { short: "SR", flag: "🇸🇷", name: "Suriname", code: "+597" },
  { short: "ST", flag: "🇸🇹", name: "Sao Tome and Principe", code: "+239" },
  { short: "SV", flag: "🇸🇻", name: "El Salvador", code: "+503" },
  { short: "SY", flag: "🇸🇾", name: "Syrian Arab Republic", code: "+963" },
  { short: "SZ", flag: "🇸🇿", name: "Swaziland", code: "+268" },
  { short: "TC", flag: "🇹🇨", name: "Turks and Caicos Islands", code: "+1 649" },
  { short: "TD", flag: "🇹🇩", name: "Chad", code: "+235" },
  { short: "TG", flag: "🇹🇬", name: "Togo", code: "+228" },
  { short: "TH", flag: "🇹🇭", name: "Thailand", code: "+66" },
  { short: "TJ", flag: "🇹🇯", name: "Tajikistan", code: "+992" },
  { short: "TK", flag: "🇹🇰", name: "Tokelau", code: "+690" },
  { short: "TL", flag: "🇹🇱", name: "Timor-Leste", code: "+670" },
  { short: "TM", flag: "🇹🇲", name: "Turkmenistan", code: "+993" },
  { short: "TN", flag: "🇹🇳", name: "Tunisia", code: "+216" },
  { short: "TO", flag: "🇹🇴", name: "Tonga", code: "+676" },
  { short: "TR", flag: "🇹🇷", name: "Turkey", code: "+90" },
  { short: "TT", flag: "🇹🇹", name: "Trinidad and Tobago", code: "+1 868" },
  { short: "TV", flag: "🇹🇻", name: "Tuvalu", code: "+688" },
  { short: "TW", flag: "🇹🇼", name: "Taiwan", code: "+886" },
  { short: "TZ", flag: "🇹🇿", name: "Tanzania", code: "+255" },
  { short: "UA", flag: "🇺🇦", name: "Ukraine", code: "+380" },
  { short: "UG", flag: "🇺🇬", name: "Uganda", code: "+256" },
  { short: "US", flag: "🇺🇸", name: "United States", code: "+1" },
  { short: "UY", flag: "🇺🇾", name: "Uruguay", code: "+598" },
  { short: "UZ", flag: "🇺🇿", name: "Uzbekistan", code: "+998" },
  { short: "VA", flag: "🇻🇦", name: "Vatican City", code: "+379" },
  {
    short: "VC",
    flag: "🇻🇨",
    name: "Saint Vincent and The Grenadines",
    code: "+1 784",
  },
  { short: "VE", flag: "🇻🇪", name: "Venezuela", code: "+58" },
  { short: "VG", flag: "🇻🇬", name: "Virgin Islands, British", code: "+1 284" },
  { short: "VI", flag: "🇻🇮", name: "Virgin Islands, U.S.", code: "+1 340" },
  { short: "VN", flag: "🇻🇳", name: "Viet Nam", code: "+84" },
  { short: "VU", flag: "🇻🇺", name: "Vanuatu", code: "+678" },
  { short: "WF", flag: "🇼🇫", name: "Wallis and Futuna", code: "+681" },
  { short: "WS", flag: "🇼🇸", name: "Samoa", code: "+685" },
  { short: "YE", flag: "🇾🇪", name: "Yemen", code: "+967" },
  { short: "YT", flag: "🇾🇹", name: "Mayotte", code: "+262" },
  { short: "ZA", flag: "🇿🇦", name: "South Africa", code: "+27" },
  { short: "ZM", flag: "🇿🇲", name: "Zambia", code: "+260" },
  { short: "ZW", flag: "🇿🇼", name: "Zimbabwe", code: "+263" },
] as const;

function compare(a: any, b: any) {
  if (a.name < b.name) {
    return -1;
  }
  if (a.name > b.name) {
    return 1;
  }
  return 0;
}

countries.sort(compare);

const countries_options = countries.map((c) =>
  Object({
    label: c.name,
    value: c.short, // Keep uppercase codes (FR, US, etc.) to match DB
  }),
);

const prefix_phone_options = countries.map((c) =>
  Object({
    label: `${c.flag} ${c.code}`,
    value: c.short.toLowerCase(),
  }),
);

const institutional_investor =
  "I am an institutional investor or a qualified investor. I acknowledge that this website is not intended for use by retail investors, and in particular by retail investors located within the United Kingdom.";

export {
  countries,
  countries_options,
  institutional_investor,
  prefix_phone_options,
};

/**
 * Preprocessing function to transform country short codes to full names
 */
export const preprocessCountryData = (key: string, value: any) => {
  if (
    (key === "country" || key === "custodian_country_code") &&
    value &&
    typeof value === "string"
  ) {
    // Find the country by short code and return the full name
    const country = countries.find((c: CountryType) => c.short === value);
    return country ? country.name : value;
  }
  return value;
};

/**
 * Transform country names back to short codes for API submission
 */
export const adjustDataForSubmission = (data: any) => {
  if (data.country && typeof data.country === "string") {
    // Find the country by name and return the short code
    const country = countries.find((c: CountryType) => c.name === data.country);
    return {
      ...data,
      country: country ? country.short : data.country,
    };
  }
  if (data.bank_country && typeof data.bank_country === "string") {
    // Find the country by name and return the short code
    const country = countries.find(
      (c: CountryType) => c.name === data.bank_country,
    );
    return {
      ...data,
      bank_country: country ? country.short : data.bank_country,
    };
  }
  if (
    data.custodian_country_code &&
    typeof data.custodian_country_code === "string"
  ) {
    // Find the country by name and return the short code
    const country = countries.find(
      (c: CountryType) => c.name === data.custodian_country_code,
    );
    return {
      ...data,
      custodian_country_code: country ? country.short : data.custodian_country_code,
    };
  }
  return data;
};
